import { useConfig } from "@/context/use-context";
import { useMutation } from "@tanstack/react-query";
import API from "./api";

interface AlertResponse {
	customer_id: string;
	email_enabled: boolean;
	sms_enabled: boolean;
	push_enabled: boolean;
	email_address: string;
	phone_number: string;
	creation_date: string;
	update_date: string;
}

export const updateSettings = async ({
	BEARER_TOKEN,
	email_enabled,
	sms_enabled,
	push_enabled,
}: {
	BEARER_TOKEN: string;
	email_enabled: boolean;
	sms_enabled: boolean;
	push_enabled: boolean;
}): Promise<AlertResponse> => {
	const response = await API.post(
		"/notifications/settings",
		{ email_enabled, sms_enabled, push_enabled },
		{ headers: { Authorization: `Bearer ${BEARER_TOKEN}` } },
	);
	return response.data;
};

// React Query Hook
export const useUpdateSettings = () => {
	const config = useConfig();

	return useMutation({
		mutationFn: (settings: {
			email_enabled: boolean;
			sms_enabled: boolean;
			push_enabled: boolean;
		}) =>
			updateSettings({
				BEARER_TOKEN: config.bearerToken,
				...settings,
			}),
	});
};
